import React, { useEffect, useState } from "react";
import {
    Table,
    Row,
    Col,
    Form,
} from "react-bootstrap";
import { Link, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getstudentFeesDetails } from "../../store/slices/fees";
import { toast } from "react-hot-toast";
import { getallstudent } from "../../store/slices/student";
import {
    FiHome,
    FiChevronRight,
} from "react-icons/fi";

export default function StudentFees() {
    const dispatch = useDispatch();

    const { studentFeeDetails = [], loading, error } = useSelector(
        (state) => state.fees || {}
    );

    const { studentlist = [] } = useSelector(
        (state) => state.student || {}
    );

    console.log(studentFeeDetails)

    const [searchStandard, setSearchStandard] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(25);
    const [selectedStudentId, setSelectedStudentId] = useState("");

    const getParentId = () => {
        try {
            const stored = JSON.parse(localStorage.getItem("user"));
            return stored?.data?.parentId || "";
        } catch (e) {
            return "";
        }
    };

    const getCurrentSession = () => {
        const now = new Date();
        const startYear = now.getFullYear();
        const endYear = String(startYear + 1).slice(-2);

        return `${startYear}-${endYear}`;
    };

    const currentSession = getCurrentSession();


    useEffect(() => {
        const parentId = getParentId();
        if (parentId) {
            dispatch(getallstudent(parentId));
        } else {
            toast.error("Parent info not found, please login again");
        }
    }, [dispatch]);


    useEffect(() => {
        if (studentlist?.length > 0 && !selectedStudentId) {
            const firstStudentId = studentlist[0]._id;
            setSelectedStudentId(firstStudentId);
        }
    }, [studentlist, selectedStudentId]);


    useEffect(() => {
        if (selectedStudentId) {
            dispatch(
                getstudentFeesDetails({ studentId: selectedStudentId, session: currentSession })
            );
        }
    }, [dispatch, selectedStudentId]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchStandard]);

    useEffect(() => {
        if (error) toast.error(error);
    }, [error]);

    const handleStudentChange = (e) => {
        const studentId = e.target.value;
        setSelectedStudentId(studentId);
    };


    const filteredData = (studentFeeDetails || []).filter((item) =>
        item.feeCategoryName
            ?.toLowerCase()
            .includes(searchStandard.toLowerCase())
    );

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    return (
        <>      <div className="page-header">
            <div className="breadcrumb-section">

                <div className="breadcrumb-left">
                    <div className="home-icon">
                        <Link to="/student/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
                    </div>


                    <FiChevronRight className="separator" />

                    <span className="active">Fees</span>
                </div>

            </div>
        </div>

            <div className="staff-card">
                <Row className="align-items-center mb-3">

                    <Col
                        md={12}
                        className="staff-tools d-flex align-items-center justify-content-end gap-2"
                    >


                        <Form.Select
                            value={selectedStudentId}
                            onChange={handleStudentChange}
                            disabled={studentlist.length === 0}
                            style={{ maxWidth: "220px" }}
                        >
                            {studentlist.length === 0 && (
                                <option value="">No students found</option>
                            )}
                            {studentlist.map((student) => (
                                <option key={student._id} value={student._id}>
                                    {student.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                </Row>

                {/* ---------- Table */}
                <div className="table-responsive">
                    <Table className="staff-table align-middle">
                        <thead>
                            <tr>

                                <th>#</th>
                                <th>Fees Category</th>
                                <th>Total Amount</th>
                                <th>Paid</th>
                                <th>Discount</th>
                                <th>Due</th>
                                <th>Term / Installments</th>
                            </tr>
                        </thead>

                        <tbody>

                            {loading &&
                                Array.from({ length: 1 }).map((_, i) => (
                                    <tr key={i}>
                                        <small>Loading...</small>
                                    </tr>
                                ))}


                            {!loading && error && (
                                <tr>
                                    <td colSpan="8" className="text-center text-danger">
                                        Failed to load fees data
                                    </td>
                                </tr>
                            )}


                            {!loading && !error && paginatedData.length === 0 && (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        No fees data found
                                    </td>
                                </tr>
                            )}


                            {!loading &&
                                !error &&
                                paginatedData.map((item, index) => (
                                    <tr key={item.feeCategoryId}>

                                        <td>{startIndex + index + 1}</td>
                                        <td>{item.feeCategoryName}</td>
                                        <td>₹ {item.totalAmount}</td>
                                        <td>₹ {item.totalPaid}</td>
                                        <td>₹ {item.totalDiscount}</td>
                                        <td>₹ {item.totalDue}</td>
                                        <td>
                                            {item.installments?.map((inst, i) => (
                                                <div
                                                    key={i}
                                                    className="mb-1"
                                                    style={{ whiteSpace: "nowrap" }}
                                                >
                                                    {inst.installmentName} – ₹ {inst.amount}{" "}
                                                    <span
                                                        style={{
                                                            color:
                                                                inst.status === "Paid"
                                                                    ? "green"
                                                                    : "#d9534f",
                                                            fontWeight: 600,
                                                            marginLeft: "4px",
                                                        }}
                                                    >
                                                        ({inst.status})
                                                    </span>
                                                </div>
                                            ))}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </div>


            </div>
        </>
    );
}